import { MissionSummary, setMissionStatus } from '@wwf/sdk';
import { useNotify, useRefresh, Button } from 'react-admin';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';

export const ArchiveButton = ({ record }: { record: MissionSummary }) => {
    const notify = useNotify();
    const refresh = useRefresh();

    const handleClick = () => {
        void setMissionStatus(record.id, { status: 'ARCHIVED' })
            .then(() => {
                notify('Mission archived', {
                    type: 'info',
                    undoable: false,
                });
                refresh();
            })
            .catch(error => {
                console.error(error);
                notify('Error: mission not archived', { type: 'error' });
            });
    };

    return (
        <Button
            onClick={handleClick}
            startIcon={<ArchiveIcon />}
            size="small"
            label={'Archive'}
        />
    );
};

export const UnarchiveButton = ({ record }: { record: MissionSummary }) => {
    const notify = useNotify();
    const refresh = useRefresh();

    const handleClick = () => {
        void setMissionStatus(record.id, { status: 'DRAFT' })
            .then(() => {
                notify('Mission unarchived', {
                    type: 'info',
                    undoable: false,
                });
                refresh();
            })
            .catch(error => {
                console.error(error);
                notify('Error: mission not unarchived', { type: 'error' });
            });
    };
    return (
        <Button
            onClick={handleClick}
            startIcon={<UnarchiveIcon />}
            size="small"
            label={'Unarchive'}
        />
    );
};
